// Refresh the readyForCheck, readyForApproval and approved columns of the total hours row
// Its value is derived from other rows in the grid, so we need to recalculate it when any of those rows change

import React from "react"
import { TreeGridApprovedHourDateGroup } from "./rows/types"
import { refreshTotalHoursRow } from "./rows/total-hours-row"

export const useRefreshTotalHoursRow = (
  gridId: string,
  gridData: TreeGridApprovedHourDateGroup[],
  isMemberSubContext: boolean
) => {
  React.useEffect(() => {
    refreshTotalHoursRow(gridId, gridData, isMemberSubContext)
  }, [gridId, gridData, isMemberSubContext])

  return {
    refreshTotalHoursRow: () => refreshTotalHoursRow(gridId, gridData, isMemberSubContext),
  }
}
